import { CdkDrag } from "@angular/cdk/drag-drop";
import { ChangeDetectionStrategy, Component, ElementRef, Input, OnInit, ViewChild, ViewEncapsulation } from "@angular/core";
import { IPDFDocumentDto } from "core/dto";
import { DynamicFormService } from "core/dynamic-form";
import { BehaviorSubject, Subject, debounceTime, distinctUntilChanged, fromEvent, map, takeUntil } from "rxjs";
import { DocumentCollectionService } from "../document-collection.service";


@Component({
  selector: 'ss-document-item',
  templateUrl: './document-item.component.html',
  styleUrls: ['./document-item.component.css'],
  providers: [
    DynamicFormService
  ],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DocumentItemComponent implements OnInit {

  private readonly _destroy = new Subject<void>();

  @ViewChild('input')
  _inputRef!: ElementRef<HTMLInputElement>
  @ViewChild(CdkDrag)
  private _cdkDrag!: CdkDrag

  readonly showErrorSubject = new BehaviorSubject<boolean>(true);

  readonly idxSubject = new BehaviorSubject<number>(0)
  @Input() get idx() {
    return this.idxSubject.value;
  }
  set idx(value: number) {
    this.idxSubject.next(value);
  }


  readonly pdfDocumentSubject = new BehaviorSubject<IPDFDocumentDto>(undefined);
  @Input() get pdfDocument() {
    return this.pdfDocumentSubject.value;
  }
  set pdfDocument(value) {
    this.pdfDocumentSubject.next(value);

    const formGroup = this.mainFormGroupSubject.value;
    formGroup.setValue({ name: this.pdfDocument?.name })

  }

  @Input()
  select = false;


  readonly pdfDocumentsSubject = this._documentCollectionService.pdfDocumentsSubject;
  readonly mainFormGroupSubject = this._dynamicFormService.mainFormGroupSubject;

  constructor(
    private _documentCollectionService: DocumentCollectionService,
    private _dynamicFormService: DynamicFormService
  ) {

    this._dynamicFormService.controls = [
      {
        dataField: 'name',
        type: 'text',
        validationRules: [{ type: 'required', message: 'Polje obavezno' }],
        label: 'ss-entities.document.name',
        defaultValue: this.pdfDocument?.name || ''
      }
    ]
  }

  ngOnInit(): void {

  }

  ngAfterViewInit() {


    const inputElement = this._inputRef.nativeElement

    fromEvent(inputElement, 'change')
      .pipe(
        debounceTime(20),
        takeUntil(this._destroy),
        map((evParams) => <HTMLInputElement>evParams.target),
        map((input) => Boolean(input.value)),
        distinctUntilChanged(),
      )
      .subscribe(hasValue => this.showErrorSubject.next(!hasValue))


    fromEvent(inputElement, 'focus')
      .pipe(takeUntil(this._destroy))
      .subscribe(() => {
        inputElement.select();
      })


  }

  removeDocument() {
    const pdfDocuments = this.pdfDocumentsSubject.value;

    const newPdfDocuments = pdfDocuments.filter(({ id }) => id !== this.pdfDocument?.id);
    this.pdfDocumentsSubject.next(newPdfDocuments);

    this._documentCollectionService.remove(this.pdfDocument?.id!);
  }


  trackById(idx: number, doc: IPDFDocumentDto) {

    return 'document-item-' + doc.id;
  }
}
